import { render, staticRenderFns } from "./NvList.vue?vue&type=template&id=48833797&scoped=true&"
import script from "./NvList.ts?vue&type=script&lang=ts&"
export * from "./NvList.ts?vue&type=script&lang=ts&"
import style0 from "./NvList.vue?vue&type=style&index=0&id=48833797&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48833797",
  null
  
)

export default component.exports